import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from './Icons';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Esto es otro libro de manifestación?',
    a: 'No. El Protocolo RNS está basado en neuroplasticidad, regulación del sistema nervioso parasimpático y Experiencia Somática, disciplinas con respaldo científico publicado. No hay vibras ni pensamiento mágico. Hay biología aplicada.'
  }, {
    q: '¿Cuánto tiempo requiere al día?',
    a: 'Entre 10 y 15 minutos diarios durante 21 días. Está diseñado para personas con agendas ocupadas y puede integrarse en tu rutina existente.'
  }, {
    q: '¿Funciona si ya leí muchos libros sin resultado?',
    a: 'El Protocolo RNS fue diseñado específicamente para personas que ya tienen el conocimiento pero no ven resultados. El problema no era el conocimiento, era el estado del sistema nervioso que impedía aplicarlo.'
  }, {
    q: '¿En qué formato recibo el libro?',
    a: 'Recibes un archivo PDF descargable inmediatamente después de tu compra. El enlace llega a tu email en menos de 5 minutos.'
  }, {
    q: '¿Está en español?',
    a: 'Sí. Completamente en español, diseñado específicamente para la comunidad hispana en Estados Unidos.'
  }, {
    q: '¿Necesito conocimiento previo de neurociencia?',
    a: 'Ninguno. Toda la ciencia está explicada en lenguaje claro y accesible. El glosario define los 12 términos técnicos clave del protocolo.'
  }, {
    q: '¿Cómo sé que el protocolo funciona?',
    a: 'El libro incluye una tabla de seguimiento de 21 días con un indicador de estrés financiero corporal del 1 al 10. La mayoría reporta reducción del 40 al 70 por ciento al finalizar.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 30 días de garantía total. Si el protocolo no cumplió tus expectativas escríbenos y te devolvemos el 100% de tu inversión. Sin preguntas ni condiciones.'
  }];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12" data-id="element-13">
      <div className="max-w-[720px] mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-15">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white" data-id="element-16">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-17">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-secondary border border-card rounded-lg overflow-hidden" data-id="element-18">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full text-left px-4 md:px-6 py-4 md:py-5 flex items-center justify-between focus:outline-none" data-id="element-19">
                <span className="font-inter font-semibold text-sm md:text-base text-warm-white pr-3 md:pr-4" data-id="element-20">
                  {faq.q}
                </span>
                <span className="text-gold flex-shrink-0" data-id="element-21">
                  {openIndex === idx ? <MinusIcon className="w-5 h-5" data-id="element-22" /> : <PlusIcon className="w-5 h-5" data-id="element-23" />}
                </span>
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-4 md:px-6 pb-4 md:pb-5 font-inter text-sm md:text-base text-warm-muted leading-relaxed text-center" data-id="element-26">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}